export interface FeaturesAvailabilityBIParams {
  isUsingDragAndDrop?: boolean | null;
  isDisablingSearch?: boolean | null;
  isUsingBulkActionsToolbar?: boolean | null;
  isUsingFilters?: boolean | null;
  isUsingHorizontalScroll?: boolean | null;
  isUsingFolders?: boolean | null;
  isUsingCounterInHeader?: boolean | null;
  isUsingTableVirtualization?: boolean | null;
  isUsingTabs?: boolean | null;
  isUsingTags?: boolean | null;
  isUsingSummaryRow?: boolean | null;
  isUsingSecondaryActions?: boolean | null;
  isUsingMoreActions?: boolean | null;
}

export interface AdditionalFeaturesAvailabilityBIParams {
  isUsingTableSubtitle?: boolean | null;
  isUsingCounterInHeader?: boolean | null;
  isUsingSelectAllLimitation?: boolean | null;
  isUsingErrorMessage?: boolean | null;
  isUsingAllItemsView?: boolean | null;
  isUsingCustomEmptyState?: boolean | null;
  isUsingCustomNoResultsState?: boolean | null;
  isUsingPrimaryActionCta?: boolean | null;
  isUsingExpandCollapse?: boolean | null;
}
